module.exports = __webpack_public_path__ + "media/images/pic/talent-friendly-company-bdf5f111b06c05c97c39214b2cf6904d.png";